import { FC, Fragment, InputHTMLAttributes } from "react";

export type InputCheckprops = InputHTMLAttributes<HTMLInputElement>;
export const InputCheck: FC<InputCheckprops> = ({ ...props }) => {
  return (
    <Fragment>
      <input
        {...props}
        type="checkbox"
        className="h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-600"
      />
    </Fragment>
  );
};
